require('./src/angular-local-storage.js');
module.exports = 'LocalStorageModule';



//////////////////
// WEBPACK FOOTER
// ../~/angular-local-storage/index.js
// module id = 52
// module chunks = 1